import { Box, Header, Link, SpaceBetween } from '@cloudscape-design/components';
import { Grid } from '@cloudscape-design/components';
import { Container } from '@cloudscape-design/components';
import { User } from '../common/types';

export default function ReportCardPdfHeader(props: { user?: User }) {
  const { user } = props;
  const email = user?.email || 'reputation@realtimefeedback.com';
  // TODO get phone number from user
  return (
    <Container>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img
            src="https://cdn.aiescape.io/real-time-feedback/google-minimal-logo.png"
            height="50"
            style={{ maxWidth: '350px', height: '50px' }}
            alt="Real Time Feedback Logo"
          />
          <Header variant="h1" className="text-center">
            <Box
              variant="span"
              fontWeight="heavy"
              color="inherit"
              textAlign="center"
              fontSize="display-l"
            >
              Reputation Scorecard
            </Box>
          </Header>
        </div>
        <div className="text-right">
          <img
            src="https://www.realtimefeedback.com/wp-content/uploads/2022/06/rt-feedback-logo_white.svg"
            height="70"
            style={{ maxWidth: '350px', height: '70px' }}
            alt="Real Time Feedback Logo"
          />
        </div>
      </div>
    </Container>
  );
}
